import React from 'react';

const WriteUpSection = ({ title, content }) => {
  return (
    <div className="write-up-section">
      <h2>{title}</h2>
      <p>{content}</p>
    </div>
  );
};

export default WriteUpSection;